import moment from "moment";

import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { MessageTaskViewContainer } from "@/Communications/Components/MessageTaskView/MessageTaskViewContainer";
import { PatientMessageListItem } from "@/Patient/Models/History/PatientMessageListItem";
import { IPatientMessagesModel } from "@/Patient/Models/UI/History/IPatientMessagesModel";

interface IPatientHistoryMessagesProps {
    Model: IPatientMessagesModel;
}

class MessagesView extends React.Component<IPatientHistoryMessagesProps, any> {
    public render(): JSX.Element {
        var messagesModel: IPatientMessagesModel;
        if (this.props.Model)
            messagesModel = this.props.Model;

        return (
            <div className="medical-summary-container">
                <div className="tb medical-summary">
                    {this.leftSide(messagesModel)}
                    {messagesModel.get("ShowDetails") === true && this.rightSide()}
                    {messagesModel.get("ShowDetails") === false && this.emptyRightSide()}
                </div>
            </div>
        );
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentDidMount(): void {
        sessionStore.dispatchAsync(LocalPatientOperations.History.Message_LoadPatientMessage);
        $(window).trigger("resize");
    }

    public ShowCriteria(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Message_CriteriaClick);
    }

    public toggleDisplayMode(): void {
        LocalEvent.Dispatch(LocalPatientOperations.History.Message_ToggleListDisplayMode);
    }

    public setSelectedMessage(message: PatientMessageListItem): void {
        var operation = new LocalEvent(LocalPatientOperations.History.Message_ShowSelectedMessage);
        operation.AddItem("message", message);
        LocalEventDispatcher.dispatch(operation);
    }

    private messageList(model: IPatientMessagesModel): JSX.Element {
        var messagelist = model.get("MessageList");
        var messageRender = messagelist.map((message: PatientMessageListItem, idx: number) => {
            var date = moment(message.Model.SendDate).format("YYYY/MM/DD");
            return (
                <div className="pointer" key={"__a" + idx} onClick={this.setSelectedMessage.bind(this, message)}>
                    <div className="med-note">
                        <div className="tb">
                            <div className="tbc">
                                <p className="ellipsis"><strong>{message.Model.Subject}</strong></p>
                                <p>{message.Model.FromEmployee}</p>
                            </div>
                            <div className="tbc text-right">
                                <span className="date">{date}</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div data-hvar="40" className="note-collection scrollable">
                {messageRender}
            </div>
        );
    }

    private leftSide(model: IPatientMessagesModel): JSX.Element {
        var toggleIconCss = "toggle-icon2";
        if (this.props.Model.get("UnreadOnly")) {
            toggleIconCss += " active";
        }

        return (
            <div className="fxheight tbc full-border left-primary">
                <div className="note-search">
                    <div className="header" />
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <div className="pull-left">
                            <TextboxControl debounceMs={400} value={model.get("SearchText")} className="fullWidth" operation={LocalPatientOperations.History.Message_SearchText} placeholder={cacheStore.GetString("SearchLabel")} />
                        </div>
                    </div>
                    {model.get("IsCriteriaExpanded") === true && (
                        <div style={{ marginTop: "10px" }}>
                            <MultiDateSelector
                                id="doc_search_date_selector"
                                fullWidth={true}
                                fromMyleOperation={LocalPatientOperations.History.Message_FromDateChanged}
                                toMyleOperation={LocalPatientOperations.History.Message_ToDateChanged}
                                fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                from={model.get("DateFrom")}
                                to={model.get("DateTo")}
                            />
                        </div>
                    )}
                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        <span style={{ marginRight: "7px" }} className={toggleIconCss} onClick={this.toggleDisplayMode.bind(this)} />
                        {model.get("IsCriteriaExpanded") === true && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[-]{cacheStore.GetString("CriteriaLabel")}</a>}
                        {model.get("IsCriteriaExpanded") === false && <a className="pull-right" onClick={this.ShowCriteria.bind(this)}>[+]{cacheStore.GetString("CriteriaLabel")}</a>}
                    </div>
                </div>
                {this.messageList(model)}

            </div>
        );
    }
    private rightSide(): JSX.Element {
        return (
            <MessageTaskViewContainer
                individualMessageId={this.props.Model.get("SelectedMessageId")}
                showPatientBanner={false}
                showAddNoteControl
                title={cacheStore.GetString("MessageDetailsLabel")}
            />
        );
    }

    private emptyRightSide(): JSX.Element {
        return (
            <div className="tbc right-primary">
                <div className="scrollable">
                    <div className="summary-container no-border" />
                </div>
            </div>
        );
    }
}

export { MessagesView };
